const transformResponsiveImages = (images, aspectRatio, width) => (
  images?.file_names.reduce((acc, curr) => ([
    ...acc,
    {
      url: images.urls[curr][aspectRatio][width],
      key: curr,
    },
  ]), [])
);

export default transformResponsiveImages;
